export const validateEmail = (str) =>
  new RegExp(/([\w.\-_]+)?\w+@[\w-_]+(\.\w+){1,}/, 'igm').test(str);
